import { useNotifications } from '@decisiv/ui-components';
import { useState } from 'react';
import { postPasswordResetService } from '../services';

export default function usePasswordReset(csrfToken, successMessage) {
  const [identity, setIdentity] = useState('');
  const [fetching, setFetching] = useState(false);
  const { notify } = useNotifications();

  async function requestResetPassword() {
    setFetching(true);
    try {
      const response = await postPasswordResetService(csrfToken, identity);
      setFetching(false);
      await response.json();
      notify({
        id: 'notify-success',
        intent: 'success',
        title:
          successMessage ||
          'Password reset instructions have been sent to your registered email address.',
        duration: 15000,
        onClose: () => {},
      });
    } catch (error) {
      setFetching(false);
      notify({
        id: 'notify-error',
        intent: 'danger',
        title: error,
        duration: 15000,
        onClose: () => {},
      });
    }
  }

  return {
    identity,
    setIdentity,
    requestResetPassword,
    requestingResetPassword: fetching,
  };
}
